module.exports = __webpack_public_path__ + "img/MapUI.c75e4bec.svg";